import { useEffect, useRef, useState } from 'react';
export var useScrollWidth = () => {
  var [scrollWidth, setScrollWidth] = useState();
  var ref = useRef(null);
  useEffect(() => {
    var updateScrollWidth = () => {
      var _ref$current;

      return setScrollWidth((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollWidth);
    };

    window.addEventListener('resize', updateScrollWidth);
    updateScrollWidth();
    return () => window.removeEventListener('resize', updateScrollWidth);
  }, []);
  return {
    ref,
    scrollWidth
  };
};
//# sourceMappingURL=useScrollWidth.js.map